import { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

export const once = <T>(action: (item: T) => void): OperatorFunction<T, T> => map((item: T, index: number) => {
    if (index === 0)
        action(item);

    return item;
});

export const tapOnce = once;

export const mapOnce = <T>(action: (item: T) => T): OperatorFunction<T, T> => map((item: T, index: number) => {
    if (index === 0)
        return action(item);

    return item;
});
